export default {
  rolePermissions: {
    MANAGER_DE_SECTEUR: {
      viewIntranetControlTab: false,
      viewSynchronizationTab: true,
      viewApplicationControlTab: true,
    },
    SUPER_ADMIN: {
      viewIntranetControlTab: true,
      viewSynchronizationTab: true,
      viewApplicationControlTab: true,
    },
  },
};
